import { API_URL } from "../utils/AppApiUrl";
import { post } from "../utils/httpClient-methods";
import tokenHttpClient from "../utils/httpClient";

const SparePhotoById = async (baseURL, id, requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.sparePhotosById}`,
      requestBody
    );

    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    console.log("error", err);
    throw err;
  }
};

export default SparePhotoById;
